import { z } from 'zod';
import { WorkflowWriteBackMode } from 'libs/end-to-end/src/types/databases/workflows/workflow-write-back-mode';
import { WriteBackToFountainStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';

export const WorkflowBadLanguageDetectorWriteBackDetails = z.object({
  type: z.literal('badLanguageDetectorWriteBack'),

  strategy: WriteBackToFountainStrategy,

  mode: WorkflowWriteBackMode.optional(),

  numPreviousDaysOfApplicants: z.number().optional(),

  numberOfSamplesToSend: z.number().optional(),
});

export type WorkflowBadLanguageDetectorWriteBackDetails = z.infer<
  typeof WorkflowBadLanguageDetectorWriteBackDetails
>;
